module.exports = __webpack_public_path__ + "media/svg/Dispatch-fe017e07.svg";